import { Button, Callout } from '@dev-spendesk/grapes';

import { type Token, TokenInput } from 'common/components/TokenInput';
import { useTranslation } from 'common/hooks/useTranslation';
import { openSupportChat } from 'src/core/utils/supportChat';

import styles from './ModalMFATokenContent.module.css';

interface Props {
  hasRegeneratedMfaProcedure: boolean;
  isMfaTokenVerified: boolean;
  isMfaTokenValid: boolean;
  token: Token;
  tokenLength: number;
  handleRegenerateProcedure: () => void;
  handleTokenChange: (token: Token) => void;
  otpChannel?: 'email' | 'phone';
}

export const ModalMFATokenContent = ({
  hasRegeneratedMfaProcedure,
  isMfaTokenVerified,
  isMfaTokenValid,
  token,
  tokenLength,
  handleTokenChange,
  handleRegenerateProcedure,
  otpChannel,
}: Props) => {
  const { t } = useTranslation('global');

  const renderActions = () => {
    if (hasRegeneratedMfaProcedure) {
      // Mfa token has been regenerated but still not received
      return (
        <Button
          variant="tertiaryBrand"
          text={t('mfa.modal.code.noCodeContactUsAction')}
          onClick={() => openSupportChat()}
          hasNegativeMargins
        />
      );
    }
    if (!isMfaTokenVerified) {
      return (
        <Button
          variant="tertiaryBrand"
          text={t('mfa.modal.code.noCodeAction')}
          onClick={handleRegenerateProcedure}
          hasNegativeMargins
        />
      );
    }
    if (isMfaTokenVerified && !isMfaTokenValid) {
      return (
        <Button
          variant="tertiaryBrand"
          text={t('mfa.modal.code.noCodeWrong')}
          onClick={handleRegenerateProcedure}
          hasNegativeMargins
        />
      );
    }
  };

  return (
    <form id="mfa-form" onSubmit={(e) => e?.preventDefault()}>
      <p className="ModalMFAToken__desc">
        {t('mfa.modal.code.desc', { context: otpChannel })}
      </p>
      <div className={styles.codeInput}>
        <TokenInput
          token={token}
          tokenLength={tokenLength}
          onTokenChange={handleTokenChange}
          hasError={isMfaTokenVerified && !isMfaTokenValid}
        />
      </div>

      {hasRegeneratedMfaProcedure && (
        <Callout
          title={t('mfa.modal.code.newCode')}
          variant="success"
          className={styles.codeFeedback}
        />
      )}

      {isMfaTokenVerified &&
        !isMfaTokenValid &&
        !hasRegeneratedMfaProcedure && (
          <Callout
            title={t('mfa.modal.code.wrong')}
            variant="alert"
            className={styles.codeFeedback}
          />
        )}

      <div className={styles.messages}>{renderActions()}</div>
    </form>
  );
};
